app.directive('formProduitCustomFieldsDirective', ['crudService', function (crudService) {
    return {
        restrict: 'E',
        templateUrl: "/templates/partials/directives/forms/produit/custom_fields_form.html",
        scope: {
            produitId: '='
        },
        link: function (scope, element, attrs) {


            scope.loaded = true;
            scope.produit = {};             // produit / produit.fields = champs du produit
            scope.availableFieldTypesOptions = [];    // options des types de champ pour select
            scope.availableListeOptions = []; // options des listes pour les types list 
            scope.message = {
                'error': null,
                'success': null
            };


            /**
             * Retourne le text passé en paramètre converti en slug
             * @param {String} Text 
             */
            var slugify = function (Text) {
                return Text
                    .toLowerCase()
                    .replace(/ /g, '_')
                    .replace(/[^\w-]+/g, '')
                    ;
            };



            let loadFields = function () {
                scope.loaded = false;
                // Ajax Produit / Champs / Options types de champs
                crudService.get('/admin/produits/' + scope.produitId + '/fields/get').then(function (response) {
                    scope.loaded = true;
                    if (response) {
                        scope.produit = response.produit;
                        scope.produit.fields = response.fields;
                        scope.availableFieldTypesOptions = response.field_type_options;
                        scope.availableListeOptions = response.listes_options;
                    }
                });
            };


            loadFields();


            /**
             * Ajout d'un formulaire pour un nouveau champ à lier au produit
             */
            scope.addFieldForm = function() {
                scope.produit.fields.push({
                    produit_id: scope.produit.id,
                    settings: null,
                    type: "string"
                });
            };

            /**
             * Suppression d'un formulaire pour un nouveau champ
             */
            scope.deleteFieldForm = function(index) {
                scope.produit.fields.splice(index, 1);
            };


            /**
             * Suppression d'un champ en BDD
             * @param {Object} field
             */
            scope.deleteField = function (field) {
               
                if (field.id) {
                    field.loading = true;

                    crudService.delete(
                        '/admin/produits/' + scope.produitId + '/fields/' + field.id,  {}, {
                            error_code_ignore_modal: [500]
                        }
                    ).then(function(response)  {
                        field.loading = false;

                        if (response.success) {
                            scope.deleteProduitFieldItemOnListById(field.id);
                        } else {
                            // Affichage d'une modal en cas d'erreur
                            field.error_msg = response.message; 
                        }

                    }, function (error) {

                        if (error.data.message) {
                            field.error_msg = error.data.message;
                        } else {
                            field.error_msg = "Une erreur s'est produit à la suppression";
                        }                        

                        field.loading = false;
                    });
                    
                }
            };

            /**
             * ng-change nom
             * @param {Object} field
             */
            scope.nomChange = function (field) {
                if (field.id === undefined || field.id === null) {
                    // En mode Création : binding du nom systeme à partir du nom du champ
                    field.nom_systeme = slugify(field.nom);
                }
            };

            /**
             * Supprime un champ du scope de la liste à partir de l'ID
             * @param {int} fieldId
             */
            scope.deleteProduitFieldItemOnListById = function (fieldId) {
                let newFields = scope.produit.fields.filter(function( obj ) {
                    return obj.id !== fieldId;
                });

                scope.safeApply(function () {
                    scope.produit.fields = newFields;
                });
            };



            scope.safeApply = function (fn) {
                if (this.$root && (this.$root.$$phase == '$apply' || this.$root.$$phase == '$digest')) {
                    if (fn && (typeof (fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

        }
    };
}]);